import React from "react";
import { CommandBarButton, IconButton, Link, Stack } from "@fluentui/react";
import DetailsTable from "../../../Table/DetailsTable";
import FeatureSummary from "../../../Util/FeatureSummary";
import env from "../../../../env";

const { REACT_APP_WWW_BASE_URL } = env;

const AudioTable = ({
    audios,
    setSelectedAudioId,
    setSelectedAudioTitle,
    loading,
    deleteOnClick,
    editOnClick,
    createOnClick,
    previewOnClick
}) => {
    const columns = [
        {

            name: "ID",
            fieldName: "audioId",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: "Content ID",
            fieldName: "contentId",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: "Title",
            fieldName: "title",
            minWidth: 300,
            maxWidth: 350,
            isResizable: true
            // onRender: (item) => (
            //     // <Link href={`${REACT_APP_WWW_BASE_URL}audio/${item.slug}`} target="_blank">{item.title}</Link>
            // ),
        },
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    deleteOnClick={deleteOnClick}
                    previewOnClick={previewOnClick}
                    id={item.audioId}
                    title={item.title}
                />
            )
        },
        {
            name: "Slug",
            fieldName: "slug",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            name: "Category",
            fieldName: "category",
            minWidth: 120,
            maxWidth: 150,
            isResizable: true,
        },
        {
            name: "Evergreen",
            fieldName: "evergreen",
            minWidth: 70,
            maxWidth: 70,
            isResizable: true,
        },
        {
            name: "Status",
            fieldName: "status",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
        },
        {
            name: "Publish Date",
            fieldName: "publishDate",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
        },
        {
            name: "Custom",
            fieldName: "custom",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
        },
        {
            name: "Tags",
            fieldName: "tags",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
        },
        {
            name: "Last Updated",
            fieldName: "lastUpdated",
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
        }
    ];

    const items = audios ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedAudioId(selectedItem && selectedItem.audioId);
        setSelectedAudioTitle?.(selectedItem?.title || "");
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={"title"}
                style={{
                    position: "relative",
                    height: "80vh",
                    width: "80vw",
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Add Audio"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Audio Content"
                summary="This table displays all audio content items, including their title, category, status, and publish date. You can add, edit, or delete audio files. Audio content is primarily found as meditations on the platform."
                imageUrlPath='meditations'
            />
        </>
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
    editOnClick,
    deleteOnClick,
    title,
    id,
    ...rest
}) => {
    const menuProps = {
        items: [
            {
                key: "print",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, title),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

export default AudioTable;
